module.exports = __webpack_public_path__ + "static/media/pg2.08efe9a5.jpg";